import { render } from "./ProgressSpinner.vue?vue&type=template&id=7e70da12"
import script from "./ProgressSpinner.vue?vue&type=script&lang=js"
export * from "./ProgressSpinner.vue?vue&type=script&lang=js"
script.render = render

export default script